
import VueLoader from '../vue-loader'
import Form from './form'

document.addEventListener('turbolinks:load', () => {
  VueLoader.loadVueComponent(Form, document.getElementById('infoRequestForm'))
})
